import Cookies from 'js-cookie'
import website from '@/config/website'
import { domain } from '@/config/env'

const Authorization = website.Authorization

export function getToken() {
	const token = Cookies.get(Authorization) || ''
	return token
}

export function setToken(token: string) {
	const expireTime = new Date(new Date().getTime() + website.tokenTime * 1000)
	return Cookies.set(Authorization, token, { expires: expireTime, domain })
}

export function removeToken() {
	return Cookies.remove(Authorization)
}
